export const en = {
  'appointments.nav.group': 'Appointments',
  'appointments.nav.calendar': 'Appointments',
  'appointments.nav.myDay': 'My day',
  'appointments.nav.types': 'Appointment types',
  'appointments.nav.report': 'Sessions report',

  'appointments.title': 'Appointments',
  'appointments.description': 'One-to-one sessions by host and branch.',
  'appointments.book': 'Book for a member',
  'appointments.hours': 'Weekly hours',
  'appointments.today': 'Today',
  'appointments.previousDay': 'Previous day',
  'appointments.nextDay': 'Next day',
  'appointments.day': 'Day',
  'appointments.branch': 'Branch',
  'appointments.allBranches': 'All branches',
  'appointments.host': 'Host',
  'appointments.everyone': 'Everyone',
  'appointments.emptyDay': 'No sessions on this day',
  'appointments.emptyDayHint': 'Book one for a member, or pick another day.',
  'appointments.count.one': '{count} session',
  'appointments.count.other': '{count} sessions',
  'appointments.timeRange': '{from} – {until}',

  'appointments.detail.member': 'Member',
  'appointments.detail.lead': 'Lead',
  'appointments.detail.host': 'With',
  'appointments.detail.when': 'When',
  'appointments.detail.where': 'Where',
  'appointments.detail.payment': 'Payment',
  'appointments.detail.fromPackage': 'One session from a package',
  'appointments.detail.payAtGym': '{price}, paid at the gym',
  'appointments.detail.free': 'Free',
  'appointments.detail.note': 'Note',
  'appointments.detail.cancelledBy': 'Cancelled by {who}',
  'appointments.detail.returned': 'The session went back to the package.',
  'appointments.detail.kept': 'The session stays used.',
  'appointments.detail.paidOnline': '{price}, paid online',
  'appointments.detail.awaitingPayment': '{price}, waiting for payment until {time}',
  'appointments.detail.refundedOnline': '{price}, paid online and refunded',
  'appointments.detail.partlyRefundedOnline': '{price}, paid online, {refunded} refunded',
  'appointments.detail.unpaidOnline': '{price}, the online payment did not go through',
  'appointments.awaitingPayment': 'Waiting for payment',
  'enum.appointmentCanceller.MEMBER': 'the member',
  'enum.appointmentCanceller.HOST': 'the host',
  'enum.appointmentCanceller.STAFF': 'staff',

  'appointments.complete': 'Mark completed',
  'appointments.noShow': 'Mark no-show',
  'appointments.cancel': 'Cancel session',
  'appointments.cancelTitle': 'Cancel this session?',
  'appointments.cancelReason': 'Reason',
  'appointments.cancelInWindow': 'It starts within the gym’s cancellation window, so the package session stays used unless you give it back.',
  'appointments.cancelBeforeWindow': 'The package session goes back to the member.',
  'appointments.returnSession': 'Give the session back to the package',
  'appointments.refundOnline': 'Refund the online payment',
  'appointments.cancelBeforeWindowPaid': 'The member is refunded the online payment in full.',
  'appointments.cancelInWindowPaid': 'It starts within the gym’s cancellation window, so the online payment is kept unless you refund it.',
  'appointments.cancelUnpaid': 'The member has not paid yet. The waiting payment is called off and the time opens again.',
  'appointments.keep': 'Keep the session',
  'appointments.booked': 'Session booked',
  'appointments.cancelled': 'Session cancelled',
  'appointments.marked': 'Saved',

  'appointments.bookTitle': 'Book a session',
  'appointments.bookDescription': 'Pick the member, the kind of session and a time.',
  'appointments.member': 'Member',
  'appointments.pickMember': 'Pick a member',
  'appointments.type': 'Session',
  'appointments.pickType': 'Choose a session',
  'appointments.with': 'With',
  'appointments.anyone': 'Anyone',
  'appointments.time': 'Time',
  'appointments.pickTime': 'Choose a time',
  'appointments.noSlots': 'No open times on this day.',
  'appointments.room': 'Room',
  'appointments.noRoom': 'No room',
  'appointments.note': 'Note',
  'appointments.sessionsLeft.one': '{count} session left',
  'appointments.sessionsLeft.other': '{count} sessions left',
  'appointments.noSessionsLeft': 'No sessions left for this session type: sell a package first.',
  'appointments.confirmBook': 'Book',
  'appointments.slotWith': '{time} · {host}',

  'appointments.hoursTitle': 'Weekly hours',
  'appointments.hoursFor': 'Weekly hours: {name}',
  'appointments.hoursDescription': 'When this host takes sessions, at which branch. Public and gym holidays and approved leave are left out on their own; days off and extra hours are set by date.',
  'appointments.pickHost': 'Choose a host',
  'appointments.addWindow': 'Add hours',
  'appointments.removeWindow': 'Remove these hours',
  'appointments.weekday': 'Day',
  'appointments.from': 'From',
  'appointments.until': 'Until',
  'appointments.noHours': 'No weekly hours yet.',
  'appointments.hoursOrder': 'Hours must end after they start.',
  'appointments.hoursSaved': 'Weekly hours saved',
  'appointments.myHours': 'My weekly hours',
  'appointments.dates.button': 'Days off and extra hours',
  'appointments.dates.title': 'Days off and extra hours',
  'appointments.dates.titleFor': 'Days off and extra hours: {name}',
  'appointments.dates.description': 'Take a date, or some hours of it, off, or add hours outside the week. Members see only times that are really open.',
  'appointments.dates.previousMonth': 'Previous month',
  'appointments.dates.nextMonth': 'Next month',
  'appointments.dates.legendOff': 'Day off or leave',
  'appointments.dates.legendHoursOff': 'Hours off',
  'appointments.dates.legendExtra': 'Extra hours',
  'appointments.dates.dayOff': 'Day off',
  'appointments.dates.onLeave': 'On leave',
  'appointments.dates.holiday': 'Holiday',
  'appointments.dates.hoursOff': 'Off {hours}',
  'appointments.dates.extraAt': 'Extra hours {hours} · {branch}',
  'appointments.dates.weekly': 'Weekly hours: {hours}',
  'appointments.dates.noWeekly': 'No weekly hours on this day',
  'appointments.dates.holidayHint': 'A holiday: the weekly hours do not run, extra hours do.',
  'appointments.dates.leaveHint': 'On approved leave: no sessions this day.',
  'appointments.dates.past': 'This day has passed.',
  'appointments.dates.block': 'Block a day or hours',
  'appointments.dates.addExtra': 'Add extra hours',
  'appointments.dates.blockHint': 'Members cannot book this time. Sessions already booked in it stay booked.',
  'appointments.dates.extraHint': 'Members can book these hours on this date, on top of the week.',
  'appointments.dates.date': 'Date',
  'appointments.dates.wholeDay': 'The whole day',
  'appointments.dates.note': 'Note',
  'appointments.dates.noteHint': 'Only you and the staff who manage sessions see it.',
  'appointments.dates.remove': 'Remove',
  'appointments.dates.removed': 'Removed',
  'appointments.dates.saved': 'Saved',
  'appointments.dates.conflicts.one': '{count} session is already booked in this time',
  'appointments.dates.conflicts.other': '{count} sessions are already booked in this time',
  'appointments.dates.conflictsHint': 'They stay booked. Open the day to cancel or move them, and the member is told.',
  'appointments.dates.request': 'Request',
  'appointments.dates.showDay': 'Open the day',
  'appointments.bookForMember': 'Book for a member',
  'appointments.bookForMemberDescription': 'Book a member into your own time. It is confirmed at once and the member is told.',
  'appointments.bookForLead': 'Book a tour for {name}',
  'appointments.bookForLeadDescription': 'A tour or consultation with a member of staff, for someone who is not a member yet. The lead moves to Tour booked.',
  'appointments.noLeadTypes': 'No session can be booked for a lead yet: add an appointment type a member of staff gives without a package, such as a gym tour.',
  'appointments.hostBookPackageHint': 'A session comes off the member’s package if they have one left; otherwise they pay at the desk.',

  'appointments.myDay.title': 'My day',
  'appointments.myDay.description': 'Your sessions. Mark each one once it has started.',
  'appointments.myDay.empty': 'No sessions on this day',
  'appointments.myDay.emptyHint': 'Members book your open weekly hours.',
  'appointments.myDay.notHost': 'Your login is not linked to a trainer at this gym.',

  'appointments.requests.title': 'Requests',
  'appointments.requests.description': 'Members wait for your answer. A request left unanswered lapses at the time shown, and the time opens again.',
  'appointments.requests.respondBy': 'Answer by {time}',
  'appointments.requests.approve': 'Approve',
  'appointments.requests.decline': 'Decline',
  'appointments.requests.approved': 'Approved. The member is told.',
  'appointments.requests.declined': 'Declined. The member is told why.',
  'appointments.requests.declineTitle': 'Decline this request?',
  'appointments.requests.reason': 'Why (the member reads this)',
  'appointments.requests.reasonHint': 'At least {min} characters.',
  'appointments.requests.reasonCount': '{count}/{max}',
  'appointments.requests.declineFrees': 'The time opens again, and a package session goes back to the member.',
  'appointments.approval.PENDING': 'Request',
  'appointments.approval.DECLINED': 'Declined',
  'appointments.approval.EXPIRED': 'Lapsed',
  'appointments.detail.declineReason': 'Why it was declined',
  'appointments.detail.lapsed': 'Nobody answered the request in time.',

  'appointments.types.title': 'Appointment types',
  'appointments.types.description': 'The one-to-one sessions the gym offers. A type booked from packages is sold as a session package under Plans.',
  'appointments.types.add': 'Add type',
  'appointments.types.edit': 'Edit {name}',
  'appointments.types.empty': 'No appointment types yet',
  'appointments.types.emptyHint': 'Add personal training, a tour or a consultation.',
  'appointments.types.name': 'Name',
  'appointments.types.displayName': 'Name shown to members',
  'appointments.types.descriptionField': 'Description',
  'appointments.types.duration': 'Length (minutes)',
  'appointments.types.hostKind': 'Given by',
  'enum.appointmentHostKind.TRAINER': 'A trainer',
  'enum.appointmentHostKind.STAFF': 'Staff with a role',
  'appointments.types.hostRole': 'Role',
  'appointments.types.usesPackage': 'Booked from a session package',
  'appointments.types.usesPackageHint': 'Each booking takes one session. Sell the sessions as a session package under Plans.',
  'appointments.types.price': 'Price per session ({currency})',
  'appointments.types.priceHint': 'Paid at the gym; 0 is free.',
  'appointments.types.memberBookable': 'Members book it themselves',
  'appointments.types.approval': "Host's approval",
  'appointments.types.approvalGymOn': 'As the gym sets it (now: the host approves)',
  'appointments.types.approvalGymOff': 'As the gym sets it (now: booked straight away)',
  'appointments.types.approvalAlways': 'The host approves every booking',
  'appointments.types.approvalNever': 'Booked straight away',
  'appointments.types.approvalHint': "A member's booking waits for the host's yes; a decline needs a reason the member reads.",
  'appointments.types.asksHost': 'Host approves',
  'appointments.types.color': 'Colour',
  'appointments.types.sortOrder': 'Order',
  'appointments.types.trainers': 'Trainers who give it',
  'appointments.types.trainersAll': 'Every trainer gives it. Tick some to limit it to them.',
  'appointments.types.trainersSome': 'Only the ticked trainers give it; members see only their times.',
  'appointments.types.retired': 'Retired',
  'appointments.types.staffOnly': 'Booked by staff',
  'appointments.types.retire': 'Retire',
  'appointments.types.restore': 'Offer again',
  'appointments.types.showRetired': 'Show retired',
  'appointments.types.saved': 'Appointment type saved',
  'appointments.types.summaryPackage': '{minutes} min · from a package',
  'appointments.types.summaryPrice': '{minutes} min · {price}',
  'appointments.types.summaryFree': '{minutes} min · free',
  'appointments.types.save': 'Save',

  'appointments.report.title': 'Sessions report',
  'appointments.report.description': 'Sessions by host and how they went, session packages sold and sessions members still hold.',
  'appointments.report.from': 'From',
  'appointments.report.to': 'To',
  'appointments.report.hosts': 'Sessions by host',
  'appointments.report.host': 'Host',
  'appointments.report.booked': 'Booked',
  'appointments.report.completed': 'Completed',
  'appointments.report.noShow': 'No-show',
  'appointments.report.cancelled': 'Cancelled',
  'appointments.report.noSessions': 'No sessions in these dates.',
  'appointments.report.packages': 'Session packages sold',
  'appointments.report.plan': 'Plan',
  'appointments.report.sold': 'Sold',
  'appointments.report.paid': 'Paid',
  'appointments.report.noPackages': 'No session packages sold in these dates.',
  'appointments.report.outstanding': 'Sessions members hold',
  'appointments.report.outstandingHint.one': 'In {count} package that has not expired',
  'appointments.report.outstandingHint.other': 'In {count} packages that have not expired',

  'admin.apiError.HOST_BUSY': 'This host already has a session at that time.',
  'admin.apiError.ROOM_BUSY': 'This room is taken at that time.',
  'admin.apiError.MEMBER_BUSY': 'This member already has a session at that time.',
  'admin.apiError.SLOT_UNAVAILABLE': 'This time is no longer open. Pick another.',
  'admin.apiError.NO_SESSIONS_LEFT': 'No sessions left for this session type. Buy a package first.',
  'admin.apiError.NO_CLASS_VISITS_LEFT': 'No class-pack visit is left that is valid when this class starts.',
  'admin.apiError.HOST_AWAY': 'This host is on leave that day.',
  'admin.apiError.DATE_PAST': 'Pick a date that has not passed.',
  'admin.apiError.HOST_BLOCKED': 'This host has taken that time off.',
  'admin.apiError.HOST_NOT_FOR_TYPE': 'This trainer does not give this appointment.',
  'admin.apiError.TYPE_NOT_FOR_LEADS': 'A lead can be booked only for a session a member of staff gives without a package.',
  'admin.apiError.ONE_PERSON': 'Book for a member or for a lead, not both.',
  'admin.apiError.APPOINTMENT_STARTED': 'This session has already started.',
  'admin.apiError.APPOINTMENT_NOT_STARTED': 'Mark a session once it has started.',
  'admin.apiError.APPOINTMENT_IN_PAST': 'Pick a time that has not passed.',
  'admin.apiError.BEYOND_HORIZON': 'That is further ahead than sessions can be booked.',
  'admin.apiError.TYPE_NOT_BOOKABLE': 'Book this session at the gym.',
  'admin.apiError.ONLINE_PAYMENT_REQUIRED': 'This gym takes payment for a session online, when it is booked.',
  'admin.apiError.ONLINE_PAYMENT_UNAVAILABLE': 'Online payment is not available right now. Try again in a moment, or ask the gym to book it.',
  'admin.apiError.HOURS_OVERLAP': 'Two sets of hours on the same day overlap.',
  'admin.apiError.HOURS_INVALID': 'Hours must end after they start.',
  'admin.apiError.HOST_ROLE_REQUIRED': 'Choose the role whose people give this session.',
  'admin.apiError.PACKAGE_INCOMPLETE': 'A session package needs a session type and a number of sessions; a class pack needs classes and a number of visits.',
  'admin.apiError.TYPE_NOT_PACKAGED': 'This session type is not booked from packages.',
  'admin.apiError.PLAN_KIND_FIXED': 'A plan stays a membership, a session package or a class pack. Create a new plan instead.',
  'admin.apiError.PLAN_IS_PACKAGE': 'A session package is sold, not given as a membership.',
  'admin.apiError.DECLINE_REASON_REQUIRED': 'Tell the member why, in {min} to {max} characters.',
  'admin.apiError.ALREADY_DECIDED': 'This request has already been answered.',
  'admin.apiError.REQUEST_PENDING': 'Approve or decline this request first.',

  'gymSettings.tab.appointments': 'Appointments',
  'gymSettings.appointments.title': 'One-to-one sessions',
  'gymSettings.appointments.description': 'How far ahead and how late members book sessions, and when a cancelled package session goes back.',
  'gymSettings.appointments.horizon': 'Book up to (days ahead)',
  'gymSettings.appointments.notice': 'Book at least (minutes before)',
  'gymSettings.appointments.window': 'Cancellation window (hours)',
  'gymSettings.appointments.windowHint': 'A package session cancelled later than this before it starts stays used.',
  'gymSettings.appointments.reminder': 'Reminder (minutes before)',
  'gymSettings.appointments.reminderHint': '0 sends no reminder.',
  'gymSettings.appointments.approval': "Trainers and therapists approve members' bookings",
  'gymSettings.appointments.approvalHint': "A member's booking of a trainer or a massage therapist waits for their yes, and a decline needs a reason. An appointment type can choose otherwise.",
  'gymSettings.appointments.requestTtl': 'Time to answer (hours)',
  'gymSettings.appointments.requestTtlHint': 'A request nobody answers lapses after this.',
  'gymSettings.appointments.requestCutoff': 'Answer at the latest (minutes before)',
  'gymSettings.appointments.requestCutoffHint': 'A request also lapses this long before the session, and members request no later than this.',
  'gymSettings.appointments.online': 'Paying for a session',
  'gymSettings.appointments.onlineNote': 'For a priced session that is not from a package. Packages and sessions that wait for the host’s yes are always paid at the gym. Online payment starts once the gym has a working payment provider.',
  'gymSettings.appointments.online.OFF': 'Members pay at the gym',
  'gymSettings.appointments.onlineHint.OFF': 'The price is shown; nobody pays online for a single session.',
  'gymSettings.appointments.online.OPTIONAL': 'Members choose',
  'gymSettings.appointments.onlineHint.OPTIONAL': 'Members pay online when they book, or at the gym.',
  'gymSettings.appointments.online.REQUIRED': 'Members pay online',
  'gymSettings.appointments.onlineHint.REQUIRED': 'A booking is held for 20 minutes while the member pays, and released if they don’t.',

  'plans.admin.field.kind': 'Sells',
  'enum.planKind.MEMBERSHIP': 'A membership',
  'enum.planKind.SESSION_PACKAGE': 'A session package',
  'plans.admin.field.appointmentType': 'Session type',
  'plans.admin.field.pickAppointmentType': 'Choose a session type',
  'plans.admin.field.sessionCount': 'Sessions',
  'plans.admin.field.validDays': 'Valid for (days)',
  'plans.admin.packageHint': 'Sold like any plan; paid, it gives the member these sessions to book. It gives no membership.',
  'plans.admin.noPackageTypes': 'Add an appointment type booked from packages first.',
  'plans.admin.badge.package': 'Session package',
  'plans.package.one': '{count} session, used within {days} days',
  'plans.package.other': '{count} sessions, used within {days} days',
  'plans.admin.pickerPackage.one': '{count} session',
  'plans.admin.pickerPackage.other': '{count} sessions',
  'plans.admin.kind.classPack': 'A class pack',
  'plans.admin.field.classes': 'Classes',
  'plans.admin.field.classesHint': 'Each visit books a place in one of these classes.',
  'plans.admin.field.visitCount': 'Visits',
  'plans.admin.classPackHint': 'Sold like any plan; paid, it gives the member these visits to book into the classes chosen here. It gives no membership.',
  'plans.admin.noClassesToPick': 'Add a group class first.',
  'plans.admin.badge.classPack': 'Class pack',
  'plans.classPack.one': '{count} class visit, used within {days} days',
  'plans.classPack.other': '{count} class visits, used within {days} days',
  'plans.admin.pickerClassPack.one': '{count} class visit',
  'plans.admin.pickerClassPack.other': '{count} class visits',

  'sell.sessions': 'Sessions',
  'sell.sessionsValue': '{count} until {date}',
  'sell.classVisits': 'Class visits',

  'memberSessions.nav': 'Sessions',
  'memberSessions.title': 'My sessions',
  'memberSessions.description': 'Your one-to-one sessions and the packages they come from.',
  'memberSessions.book': 'Book a session',
  'memberSessions.upcoming': 'Upcoming',
  'memberSessions.recent': 'Past',
  'memberSessions.emptyUpcoming': 'No upcoming sessions',
  'memberSessions.emptyUpcomingHint': 'Book a session to see it here.',
  'memberSessions.emptyRecent': 'No past sessions yet.',
  'memberSessions.packages': 'Sessions left',
  'memberSessions.noPackages': 'You have no session packages.',
  'memberSessions.buyPackage': 'Buy a package',
  'memberSessions.packageLeft': '{left} of {total} left',
  'memberSessions.packageUseBy': 'Use by {date}',
  'memberSessions.packageExpired': 'Expired on {date}',
  'memberSessions.packageRefunded': 'Refunded',
  'memberSessions.with': 'with {name}',
  'memberSessions.payAtGym': 'Pay {price} at the gym',
  'memberSessions.cancel': 'Cancel',
  'memberSessions.cancelTitle': 'Cancel this session?',
  'memberSessions.cancelReturns': 'The session goes back to your package.',
  'memberSessions.cancelKeeps': 'It starts in less than {hours} hours, so the session counts as used.',
  'memberSessions.cancelled': 'Session cancelled',
  'memberSessions.returned': 'Session returned to your package',
  'memberSessions.kept': 'Session counted as used',
  'memberSessions.bookTitle': 'Book a session',
  'memberSessions.bookDescription': 'Choose the session, who with, and a time that suits you.',
  'memberSessions.back': 'My sessions',
  'memberSessions.step.type': 'What',
  'memberSessions.step.host': 'With whom',
  'memberSessions.step.day': 'Which day',
  'memberSessions.step.time': 'What time',
  'memberSessions.anyone': 'Anyone free',
  'memberSessions.noTypes': 'The gym does not take bookings for sessions yet.',
  'memberSessions.noHosts': 'No one takes this session yet.',
  'memberSessions.noSlots': 'No open times on this day. Try another day.',
  'memberSessions.needPackage': 'This session is booked from a package, and you have no sessions left.',
  'memberSessions.confirmTitle': 'Book this session?',
  'memberSessions.confirm': 'Book',
  'memberSessions.booked': 'Booked. See you there!',
  'memberSessions.fromPackage': 'Takes one session from your package.',
  'memberSessions.typeLine': '{minutes} min · {detail}',
  'memberSessions.waiting': 'Waiting for confirmation',
  'memberSessions.declined': 'Declined',
  'memberSessions.lapsed': 'Not answered',
  'memberSessions.declineReason': 'Reason: {reason}',
  'memberSessions.lapsedHint': 'The request was not answered in time.',
  'memberSessions.requestTitle': 'Request this session?',
  'memberSessions.request': 'Request',
  'memberSessions.confirmsWithin': '{name} confirms within {hours} h.',
  'memberSessions.requestNote': 'You send a request, and it is confirmed within {hours} h.',
  'memberSessions.requested': 'Request sent. We will tell you when it is answered.',
  'memberSessions.withdraw': 'Withdraw',
  'memberSessions.withdrawTitle': 'Withdraw this request?',
  'memberSessions.withdrawn': 'Request withdrawn',
  'memberSessions.payNow': 'Pay now · {price}',
  'memberSessions.payOnline': 'Pay {price} online',
  'memberSessions.payAtGymAction': 'Pay at the gym',
  'memberSessions.payChoiceHint': 'Pay online now, or pay {price} at the gym. While you pay online we hold the time for you, and release it if the payment does not go through.',
  'memberSessions.payRequiredHint': 'This session is paid online. While you pay we hold the time for you, and release it if the payment does not go through.',
  'memberSessions.awaitingPayment': 'Waiting for payment',
  'memberSessions.heldUntil': 'Held for you until {time}',
  'memberSessions.completePayment': 'Pay now',
  'memberSessions.paidOnline': 'Paid online',
  'memberSessions.refundedOnline': 'Refunded',
  'memberSessions.paymentKept': 'The payment is not refunded.',
  'memberSessions.cancelRefunds': 'You get the online payment back in full.',
  'memberSessions.cancelKeepsPayment': 'It starts in less than {hours} hours, so the payment is not refunded.',
  'memberSessions.cancelReason': 'Reason: {reason}',
  'memberSessions.reason.notPaid': 'The time was released because the payment did not arrive in time.',
  'memberSessions.reason.paymentFailed': 'The time was released because the payment did not go through.',
  'memberSessions.returnPaid': 'Your session is booked.',
  'memberSessions.returnPending': 'Waiting for the bank to confirm the payment. Your time is held until it does.',
  'memberSessions.returnFailed': 'The payment did not go through and the time was released.',
  'memberSessions.returnRefunded': 'The payment was refunded.',
  'memberSessions.returnReleased': 'We received your payment, but the time had already been released. The gym has been told and will be in touch.',
  'memberSessions.viewSessions': 'View my sessions',
};

export const ka: Record<keyof typeof en, string> = {
  'appointments.nav.group': 'ინდივიდუალური ვარჯიშები',
  'appointments.nav.calendar': 'ჩანიშვნები',
  'appointments.nav.myDay': 'ჩემი დღე',
  'appointments.nav.types': 'ჩანიშვნის ტიპები',
  'appointments.nav.report': 'სესიების ანგარიში',

  'appointments.title': 'ჩანიშვნები',
  'appointments.description': 'ინდივიდუალური სესიები მასპინძლისა და ფილიალის მიხედვით.',
  'appointments.book': 'წევრისთვის დაჯავშნა',
  'appointments.hours': 'კვირის საათები',
  'appointments.today': 'დღეს',
  'appointments.previousDay': 'წინა დღე',
  'appointments.nextDay': 'შემდეგი დღე',
  'appointments.day': 'დღე',
  'appointments.branch': 'ფილიალი',
  'appointments.allBranches': 'ყველა ფილიალი',
  'appointments.host': 'მასპინძელი',
  'appointments.everyone': 'ყველა',
  'appointments.emptyDay': 'ამ დღეს სესიები არ არის',
  'appointments.emptyDayHint': 'დაუჯავშნეთ წევრს ან აირჩიეთ სხვა დღე.',
  'appointments.count.one': '{count} სესია',
  'appointments.count.other': '{count} სესია',
  'appointments.timeRange': '{from} – {until}',

  'appointments.detail.member': 'წევრი',
  'appointments.detail.lead': 'ლიდი',
  'appointments.detail.host': 'ვისთან',
  'appointments.detail.when': 'როდის',
  'appointments.detail.where': 'სად',
  'appointments.detail.payment': 'გადახდა',
  'appointments.detail.fromPackage': 'პაკეტიდან ერთი სესია',
  'appointments.detail.payAtGym': '{price}, იხდის დარბაზში',
  'appointments.detail.free': 'უფასო',
  'appointments.detail.note': 'შენიშვნა',
  'appointments.detail.cancelledBy': 'გააუქმა: {who}',
  'appointments.detail.returned': 'სესია პაკეტს დაუბრუნდა.',
  'appointments.detail.kept': 'სესია გამოყენებულად ითვლება.',
  'appointments.detail.paidOnline': '{price}, გადახდილია ონლაინ',
  'appointments.detail.awaitingPayment': '{price}, გადახდას ელოდება {time}-მდე',
  'appointments.detail.refundedOnline': '{price}, გადახდილი იყო ონლაინ და დაბრუნდა',
  'appointments.detail.partlyRefundedOnline': '{price}, გადახდილია ონლაინ, დაბრუნდა {refunded}',
  'appointments.detail.unpaidOnline': '{price}, ონლაინ გადახდა ვერ შედგა',
  'appointments.awaitingPayment': 'ელოდება გადახდას',
  'enum.appointmentCanceller.MEMBER': 'წევრმა',
  'enum.appointmentCanceller.HOST': 'მასპინძელმა',
  'enum.appointmentCanceller.STAFF': 'პერსონალმა',

  'appointments.complete': 'ჩატარდა',
  'appointments.noShow': 'არ გამოცხადდა',
  'appointments.cancel': 'სესიის გაუქმება',
  'appointments.cancelTitle': 'გავაუქმოთ ეს სესია?',
  'appointments.cancelReason': 'მიზეზი',
  'appointments.cancelInWindow': 'სესია დარბაზის გაუქმების ვადაში იწყება, ამიტომ პაკეტის სესია გამოყენებულად ჩაითვლება, თუ არ დაუბრუნებთ.',
  'appointments.cancelBeforeWindow': 'პაკეტის სესია წევრს დაუბრუნდება.',
  'appointments.returnSession': 'სესიის დაბრუნება პაკეტში',
  'appointments.refundOnline': 'ონლაინ გადახდის დაბრუნება',
  'appointments.cancelBeforeWindowPaid': 'წევრს ონლაინ გადახდილი თანხა სრულად დაუბრუნდება.',
  'appointments.cancelInWindowPaid': 'სესია დარბაზის გაუქმების ვადაში იწყება, ამიტომ ონლაინ გადახდილი თანხა არ დაბრუნდება, თუ არ დააბრუნებთ.',
  'appointments.cancelUnpaid': 'წევრს ჯერ არ გადაუხდია. მოლოდინში მყოფი გადახდა გაუქმდება და დრო ისევ გათავისუფლდება.',
  'appointments.keep': 'სესიის დატოვება',
  'appointments.booked': 'სესია დაჯავშნილია',
  'appointments.cancelled': 'სესია გაუქმდა',
  'appointments.marked': 'შენახულია',

  'appointments.bookTitle': 'სესიის დაჯავშნა',
  'appointments.bookDescription': 'აირჩიეთ წევრი, სესიის სახე და დრო.',
  'appointments.member': 'წევრი',
  'appointments.pickMember': 'აირჩიეთ წევრი',
  'appointments.type': 'სესია',
  'appointments.pickType': 'აირჩიეთ სესია',
  'appointments.with': 'ვისთან',
  'appointments.anyone': 'ნებისმიერი',
  'appointments.time': 'დრო',
  'appointments.pickTime': 'აირჩიეთ დრო',
  'appointments.noSlots': 'ამ დღეს თავისუფალი დრო არ არის.',
  'appointments.room': 'ოთახი',
  'appointments.noRoom': 'ოთახის გარეშე',
  'appointments.note': 'შენიშვნა',
  'appointments.sessionsLeft.one': 'დარჩა {count} სესია',
  'appointments.sessionsLeft.other': 'დარჩა {count} სესია',
  'appointments.noSessionsLeft': 'ამ ტიპის სესიები აღარ დარჩა: ჯერ პაკეტი მიჰყიდეთ.',
  'appointments.confirmBook': 'დაჯავშნა',
  'appointments.slotWith': '{time} · {host}',

  'appointments.hoursTitle': 'კვირის საათები',
  'appointments.hoursFor': 'კვირის საათები: {name}',
  'appointments.hoursDescription': 'როდის და რომელ ფილიალში იღებს ეს მასპინძელი სესიებს. საჯარო და დარბაზის დასვენების დღეები და დამტკიცებული შვებულება ავტომატურად გამოირიცხება; დასვენების დღეები და დამატებითი საათები თარიღის მიხედვით ინიშნება.',
  'appointments.pickHost': 'აირჩიეთ მასპინძელი',
  'appointments.addWindow': 'საათების დამატება',
  'appointments.removeWindow': 'ამ საათების წაშლა',
  'appointments.weekday': 'დღე',
  'appointments.from': 'დან',
  'appointments.until': 'მდე',
  'appointments.noHours': 'კვირის საათები ჯერ არ არის.',
  'appointments.hoursOrder': 'საათები დაწყების შემდეგ უნდა მთავრდებოდეს.',
  'appointments.hoursSaved': 'კვირის საათები შენახულია',
  'appointments.myHours': 'ჩემი კვირის საათები',
  'appointments.dates.button': 'დასვენების დღეები და დამატებითი საათები',
  'appointments.dates.title': 'დასვენების დღეები და დამატებითი საათები',
  'appointments.dates.titleFor': 'დასვენების დღეები და დამატებითი საათები: {name}',
  'appointments.dates.description': 'გამოყავით თარიღი ან მისი ნაწილი დასვენებისთვის, ან დაამატეთ საათები კვირის განრიგის გარეთ. წევრები მხოლოდ რეალურად თავისუფალ დროს ხედავენ.',
  'appointments.dates.previousMonth': 'წინა თვე',
  'appointments.dates.nextMonth': 'შემდეგი თვე',
  'appointments.dates.legendOff': 'დასვენება ან შვებულება',
  'appointments.dates.legendHoursOff': 'დაკავებული საათები',
  'appointments.dates.legendExtra': 'დამატებითი საათები',
  'appointments.dates.dayOff': 'დასვენების დღე',
  'appointments.dates.onLeave': 'შვებულებაში',
  'appointments.dates.holiday': 'უქმე დღე',
  'appointments.dates.hoursOff': 'დაკავებულია {hours}',
  'appointments.dates.extraAt': 'დამატებითი საათები {hours} · {branch}',
  'appointments.dates.weekly': 'კვირის საათები: {hours}',
  'appointments.dates.noWeekly': 'ამ დღეს კვირის საათები არ არის',
  'appointments.dates.holidayHint': 'უქმე დღეა: კვირის საათები არ მოქმედებს, დამატებითი საათები მოქმედებს.',
  'appointments.dates.leaveHint': 'დამტკიცებული შვებულება: ამ დღეს სესიები არ არის.',
  'appointments.dates.past': 'ეს დღე უკვე გავიდა.',
  'appointments.dates.block': 'დღის ან საათების დაბლოკვა',
  'appointments.dates.addExtra': 'დამატებითი საათები',
  'appointments.dates.blockHint': 'წევრები ამ დროს ვერ დაჯავშნიან. უკვე დაჯავშნილი სესიები რჩება.',
  'appointments.dates.extraHint': 'წევრებს ამ თარიღზე ამ საათების დაჯავშნა კვირის განრიგის გარდა შეეძლებათ.',
  'appointments.dates.date': 'თარიღი',
  'appointments.dates.wholeDay': 'მთელი დღე',
  'appointments.dates.note': 'შენიშვნა',
  'appointments.dates.noteHint': 'მას მხოლოდ თქვენ და სესიების მმართველი თანამშრომლები ხედავთ.',
  'appointments.dates.remove': 'წაშლა',
  'appointments.dates.removed': 'წაიშალა',
  'appointments.dates.saved': 'შენახულია',
  'appointments.dates.conflicts.one': 'ამ დროს უკვე დაჯავშნილია {count} სესია',
  'appointments.dates.conflicts.other': 'ამ დროს უკვე დაჯავშნილია {count} სესია',
  'appointments.dates.conflictsHint': 'ისინი დაჯავშნილი რჩება. გახსენით დღე, რომ გააუქმოთ ან გადაიტანოთ, და წევრს ეცნობება.',
  'appointments.dates.request': 'მოთხოვნა',
  'appointments.dates.showDay': 'დღის გახსნა',
  'appointments.bookForMember': 'წევრის ჩაწერა',
  'appointments.bookForMemberDescription': 'ჩაწერეთ წევრი თქვენს დროზე. ჯავშანი მაშინვე დასტურდება და წევრი შეტყობინებას იღებს.',
  'appointments.bookForLead': 'ტურის დაჯავშნა: {name}',
  'appointments.bookForLeadDescription': 'ტური ან კონსულტაცია თანამშრომელთან ადამიანისთვის, რომელიც ჯერ წევრი არ არის. ლიდი ეტაპზე „ტური დაჯავშნილია“ გადავა.',
  'appointments.noLeadTypes': 'ლიდისთვის ჯერ ვერაფერს დაჯავშნით: დაამატეთ ვიზიტის ტიპი, რომელსაც თანამშრომელი პაკეტის გარეშე ატარებს, მაგალითად დარბაზის ტური.',
  'appointments.hostBookPackageHint': 'თუ წევრს პაკეტში სესია დარჩა, ის იქიდან ჩამოიჭრება; თუ არა, მიმღებზე გადაიხდის.',

  'appointments.myDay.title': 'ჩემი დღე',
  'appointments.myDay.description': 'თქვენი სესიები. მონიშნეთ თითოეული, როცა დაიწყება.',
  'appointments.myDay.empty': 'ამ დღეს სესიები არ გაქვთ',
  'appointments.myDay.emptyHint': 'წევრები თქვენს თავისუფალ კვირის საათებს ჯავშნიან.',
  'appointments.myDay.notHost': 'თქვენი ანგარიში ამ დარბაზში ტრენერთან არ არის დაკავშირებული.',

  'appointments.requests.title': 'მოთხოვნები',
  'appointments.requests.description': 'წევრები თქვენს პასუხს ელოდებიან. უპასუხო მოთხოვნას მითითებულ დროს ვადა გასდის და ეს დრო ისევ თავისუფლდება.',
  'appointments.requests.respondBy': 'უპასუხეთ {time}-მდე',
  'appointments.requests.approve': 'დადასტურება',
  'appointments.requests.decline': 'უარყოფა',
  'appointments.requests.approved': 'დადასტურდა. წევრს ეცნობა.',
  'appointments.requests.declined': 'უარყოფილია. წევრს ეცნობა მიზეზი.',
  'appointments.requests.declineTitle': 'უარვყოთ ეს მოთხოვნა?',
  'appointments.requests.reason': 'მიზეზი (წევრი ამას წაიკითხავს)',
  'appointments.requests.reasonHint': 'მინიმუმ {min} სიმბოლო.',
  'appointments.requests.reasonCount': '{count}/{max}',
  'appointments.requests.declineFrees': 'დრო ისევ თავისუფლდება და პაკეტის სესია წევრს უბრუნდება.',
  'appointments.approval.PENDING': 'მოთხოვნა',
  'appointments.approval.DECLINED': 'უარყოფილი',
  'appointments.approval.EXPIRED': 'ვადაგასული',
  'appointments.detail.declineReason': 'უარის მიზეზი',
  'appointments.detail.lapsed': 'მოთხოვნას დროულად არავინ უპასუხა.',

  'appointments.types.title': 'ჩანიშვნის ტიპები',
  'appointments.types.description': 'ინდივიდუალური სესიები, რომლებსაც დარბაზი გთავაზობთ. პაკეტით დასაჯავშნი ტიპი იყიდება როგორც სესიების პაკეტი, პაკეტების გვერდზე.',
  'appointments.types.add': 'ტიპის დამატება',
  'appointments.types.edit': 'რედაქტირება: {name}',
  'appointments.types.empty': 'ჩანიშვნის ტიპები ჯერ არ არის',
  'appointments.types.emptyHint': 'დაამატეთ პერსონალური ვარჯიში, დათვალიერება ან კონსულტაცია.',
  'appointments.types.name': 'სახელი',
  'appointments.types.displayName': 'წევრებისთვის ნაჩვენები სახელი',
  'appointments.types.descriptionField': 'აღწერა',
  'appointments.types.duration': 'ხანგრძლივობა (წუთი)',
  'appointments.types.hostKind': 'ვინ ატარებს',
  'enum.appointmentHostKind.TRAINER': 'ტრენერი',
  'enum.appointmentHostKind.STAFF': 'გარკვეული როლის თანამშრომელი',
  'appointments.types.hostRole': 'როლი',
  'appointments.types.usesPackage': 'ჯავშნა სესიების პაკეტიდან',
  'appointments.types.usesPackageHint': 'ყოველი ჯავშანი ერთ სესიას იყენებს. სესიები გაყიდეთ როგორც სესიების პაკეტი, პაკეტების გვერდზე.',
  'appointments.types.price': 'ერთი სესიის ფასი ({currency})',
  'appointments.types.priceHint': 'იხდის დარბაზში; 0 ნიშნავს უფასოს.',
  'appointments.types.memberBookable': 'წევრები თავად ჯავშნიან',
  'appointments.types.approval': 'მასპინძლის დადასტურება',
  'appointments.types.approvalGymOn': 'დარბაზის პარამეტრით (ახლა: მასპინძელი ადასტურებს)',
  'appointments.types.approvalGymOff': 'დარბაზის პარამეტრით (ახლა: პირდაპირ იჯავშნება)',
  'appointments.types.approvalAlways': 'მასპინძელი ადასტურებს ყველა ჯავშანს',
  'appointments.types.approvalNever': 'პირდაპირ იჯავშნება',
  'appointments.types.approvalHint': 'წევრის ჯავშანი მასპინძლის დადასტურებას ელოდება; უარს სჭირდება მიზეზი, რომელსაც წევრი წაიკითხავს.',
  'appointments.types.asksHost': 'მასპინძელი ადასტურებს',
  'appointments.types.color': 'ფერი',
  'appointments.types.sortOrder': 'რიგი',
  'appointments.types.trainers': 'რომელი მწვრთნელები ატარებენ',
  'appointments.types.trainersAll': 'ყველა მწვრთნელი ატარებს. მონიშნეთ ზოგიერთი, რომ მხოლოდ მათ ჩაატარონ.',
  'appointments.types.trainersSome': 'მხოლოდ მონიშნული მწვრთნელები ატარებენ; წევრები მხოლოდ მათ დროს ხედავენ.',
  'appointments.types.retired': 'აღარ გვთავაზობთ',
  'appointments.types.staffOnly': 'ჯავშნის პერსონალი',
  'appointments.types.retire': 'შეწყვეტა',
  'appointments.types.restore': 'ხელახლა შეთავაზება',
  'appointments.types.showRetired': 'შეწყვეტილების ჩვენება',
  'appointments.types.saved': 'ჩანიშვნის ტიპი შენახულია',
  'appointments.types.summaryPackage': '{minutes} წთ · პაკეტიდან',
  'appointments.types.summaryPrice': '{minutes} წთ · {price}',
  'appointments.types.summaryFree': '{minutes} წთ · უფასო',
  'appointments.types.save': 'შენახვა',

  'appointments.report.title': 'სესიების ანგარიში',
  'appointments.report.description': 'სესიები მასპინძლების მიხედვით და როგორ ჩაიარა, გაყიდული სესიების პაკეტები და წევრებთან დარჩენილი სესიები.',
  'appointments.report.from': 'დან',
  'appointments.report.to': 'მდე',
  'appointments.report.hosts': 'სესიები მასპინძლების მიხედვით',
  'appointments.report.host': 'მასპინძელი',
  'appointments.report.booked': 'დაჯავშნილი',
  'appointments.report.completed': 'ჩატარებული',
  'appointments.report.noShow': 'არ გამოცხადდა',
  'appointments.report.cancelled': 'გაუქმებული',
  'appointments.report.noSessions': 'ამ თარიღებში სესიები არ ყოფილა.',
  'appointments.report.packages': 'გაყიდული სესიების პაკეტები',
  'appointments.report.plan': 'პაკეტი',
  'appointments.report.sold': 'გაიყიდა',
  'appointments.report.paid': 'გადახდილი',
  'appointments.report.noPackages': 'ამ თარიღებში სესიების პაკეტი არ გაყიდულა.',
  'appointments.report.outstanding': 'წევრებთან დარჩენილი სესიები',
  'appointments.report.outstandingHint.one': '{count} მოქმედ პაკეტში',
  'appointments.report.outstandingHint.other': '{count} მოქმედ პაკეტში',

  'admin.apiError.HOST_BUSY': 'ამ მასპინძელს ამ დროს უკვე აქვს სესია.',
  'admin.apiError.ROOM_BUSY': 'ეს ოთახი ამ დროს დაკავებულია.',
  'admin.apiError.MEMBER_BUSY': 'ამ წევრს ამ დროს უკვე აქვს სესია.',
  'admin.apiError.SLOT_UNAVAILABLE': 'ეს დრო უკვე აღარ არის თავისუფალი. აირჩიეთ სხვა.',
  'admin.apiError.NO_SESSIONS_LEFT': 'ამ ტიპის სესიები აღარ დარჩა. ჯერ შეიძინეთ პაკეტი.',
  'admin.apiError.NO_CLASS_VISITS_LEFT': 'ამ ვარჯიშის დაწყებისას მოქმედი ჯგუფური პაკეტის ვიზიტი აღარ დარჩა.',
  'admin.apiError.HOST_AWAY': 'მასპინძელი ამ დღეს შვებულებაშია.',
  'admin.apiError.DATE_PAST': 'აირჩიეთ თარიღი, რომელიც ჯერ არ გასულა.',
  'admin.apiError.HOST_BLOCKED': 'მასპინძელს ეს დრო დასვენებისთვის აქვს გამოყოფილი.',
  'admin.apiError.HOST_NOT_FOR_TYPE': 'ეს მწვრთნელი ამ ვიზიტს არ ატარებს.',
  'admin.apiError.TYPE_NOT_FOR_LEADS': 'ლიდისთვის მხოლოდ ისეთი სესიის დაჯავშნაა შესაძლებელი, რომელსაც თანამშრომელი პაკეტის გარეშე ატარებს.',
  'admin.apiError.ONE_PERSON': 'დაჯავშნეთ ან წევრისთვის, ან ლიდისთვის, ორივესთვის ერთად არა.',
  'admin.apiError.APPOINTMENT_STARTED': 'ეს სესია უკვე დაიწყო.',
  'admin.apiError.APPOINTMENT_NOT_STARTED': 'სესია მონიშნეთ, როცა დაიწყება.',
  'admin.apiError.APPOINTMENT_IN_PAST': 'აირჩიეთ დრო, რომელიც ჯერ არ გასულა.',
  'admin.apiError.BEYOND_HORIZON': 'ასე შორს წინასწარ სესიის დაჯავშნა არ შეიძლება.',
  'admin.apiError.TYPE_NOT_BOOKABLE': 'ეს სესია დარბაზში დაჯავშნეთ.',
  'admin.apiError.ONLINE_PAYMENT_REQUIRED': 'ეს დარბაზი სესიის საფასურს ჯავშნისას ონლაინ იღებს.',
  'admin.apiError.ONLINE_PAYMENT_UNAVAILABLE': 'ონლაინ გადახდა ახლა მიუწვდომელია. სცადეთ ცოტა ხანში ან სთხოვეთ დარბაზს, რომ დაგიჯავშნოთ.',
  'admin.apiError.HOURS_OVERLAP': 'ერთსა და იმავე დღეს ორი საათების მონაკვეთი ერთმანეთს ფარავს.',
  'admin.apiError.HOURS_INVALID': 'საათები დაწყების შემდეგ უნდა მთავრდებოდეს.',
  'admin.apiError.HOST_ROLE_REQUIRED': 'აირჩიეთ როლი, რომლის თანამშრომლებიც ამ სესიას ატარებენ.',
  'admin.apiError.PACKAGE_INCOMPLETE': 'სესიების პაკეტს სჭირდება სესიის ტიპი და სესიების რაოდენობა; ჯგუფური ვარჯიშების პაკეტს — ვარჯიშები და ვიზიტების რაოდენობა.',
  'admin.apiError.TYPE_NOT_PACKAGED': 'ამ ტიპის სესია პაკეტიდან არ იჯავშნება.',
  'admin.apiError.PLAN_KIND_FIXED': 'პაკეტი რჩება აბონემენტად, სესიების პაკეტად ან ჯგუფური ვარჯიშების პაკეტად. სანაცვლოდ შექმენით ახალი.',
  'admin.apiError.PLAN_IS_PACKAGE': 'სესიების პაკეტი იყიდება და აბონემენტად არ გაიცემა.',
  'admin.apiError.DECLINE_REASON_REQUIRED': 'მიუთითეთ წევრისთვის მიზეზი, {min}-დან {max} სიმბოლომდე.',
  'admin.apiError.ALREADY_DECIDED': 'ამ მოთხოვნას უკვე უპასუხეს.',
  'admin.apiError.REQUEST_PENDING': 'ჯერ დაადასტურეთ ან უარყავით ეს მოთხოვნა.',

  'gymSettings.tab.appointments': 'ჩანიშვნები',
  'gymSettings.appointments.title': 'ინდივიდუალური სესიები',
  'gymSettings.appointments.description': 'რამდენი ხნით ადრე და რა ბოლო მომენტამდე ჯავშნიან წევრები სესიებს და როდის უბრუნდებათ გაუქმებული პაკეტის სესია.',
  'gymSettings.appointments.horizon': 'ჯავშნა წინასწარ (დღე)',
  'gymSettings.appointments.notice': 'ჯავშნა მინიმუმ (წუთით ადრე)',
  'gymSettings.appointments.window': 'გაუქმების ვადა (საათი)',
  'gymSettings.appointments.windowHint': 'დაწყებამდე ამაზე გვიან გაუქმებული პაკეტის სესია გამოყენებულად ითვლება.',
  'gymSettings.appointments.reminder': 'შეხსენება (წუთით ადრე)',
  'gymSettings.appointments.reminderHint': '0 — შეხსენება არ იგზავნება.',
  'gymSettings.appointments.approval': 'ტრენერები და მასაჟისტები ადასტურებენ წევრების ჯავშნებს',
  'gymSettings.appointments.approvalHint': 'წევრის ჯავშანი ტრენერთან ან მასაჟისტთან მათ დადასტურებას ელოდება, უარს კი მიზეზი სჭირდება. ჩანიშვნის ტიპს შეუძლია სხვაგვარად აირჩიოს.',
  'gymSettings.appointments.requestTtl': 'პასუხის ვადა (საათი)',
  'gymSettings.appointments.requestTtlHint': 'უპასუხო მოთხოვნას ამ დროის შემდეგ ვადა გასდის.',
  'gymSettings.appointments.requestCutoff': 'პასუხი არაუგვიანეს (წუთით ადრე)',
  'gymSettings.appointments.requestCutoffHint': 'მოთხოვნას ვადა სესიამდე ამდენი ხნით ადრეც გასდის, და წევრები ამაზე გვიან ვერ ითხოვენ.',
  'gymSettings.appointments.online': 'სესიის გადახდა',
  'gymSettings.appointments.onlineNote': 'ეხება ფასიან სესიას, რომელიც პაკეტიდან არ იჯავშნება. პაკეტები და სესიები, რომლებიც მასპინძლის დადასტურებას ელოდება, ყოველთვის დარბაზში იხდება. ონლაინ გადახდა ამოქმედდება, როცა დარბაზს მოქმედი გადახდის პროვაიდერი ექნება.',
  'gymSettings.appointments.online.OFF': 'წევრები დარბაზში იხდიან',
  'gymSettings.appointments.onlineHint.OFF': 'ფასი ჩანს, მაგრამ ცალკეული სესიისთვის ონლაინ არავინ იხდის.',
  'gymSettings.appointments.online.OPTIONAL': 'წევრები თავად ირჩევენ',
  'gymSettings.appointments.onlineHint.OPTIONAL': 'წევრები ჯავშნისას ონლაინ იხდიან ან დარბაზში.',
  'gymSettings.appointments.online.REQUIRED': 'წევრები ონლაინ იხდიან',
  'gymSettings.appointments.onlineHint.REQUIRED': 'სანამ წევრი იხდის, ჯავშანი 20 წუთით ინახება და თუ არ გადაიხადა, თავისუფლდება.',

  'plans.admin.field.kind': 'რას ყიდის',
  'enum.planKind.MEMBERSHIP': 'აბონემენტს',
  'enum.planKind.SESSION_PACKAGE': 'სესიების პაკეტს',
  'plans.admin.field.appointmentType': 'სესიის ტიპი',
  'plans.admin.field.pickAppointmentType': 'აირჩიეთ სესიის ტიპი',
  'plans.admin.field.sessionCount': 'სესიები',
  'plans.admin.field.validDays': 'მოქმედების ვადა (დღე)',
  'plans.admin.packageHint': 'იყიდება როგორც ნებისმიერი პაკეტი; გადახდის შემდეგ წევრი ამ სესიებს ჯავშნის. აბონემენტს არ იძლევა.',
  'plans.admin.noPackageTypes': 'ჯერ დაამატეთ ჩანიშვნის ტიპი, რომელიც პაკეტიდან იჯავშნება.',
  'plans.admin.badge.package': 'სესიების პაკეტი',
  'plans.package.one': '{count} სესია, გამოსაყენებელი {days} დღეში',
  'plans.package.other': '{count} სესია, გამოსაყენებელი {days} დღეში',
  'plans.admin.pickerPackage.one': '{count} სესია',
  'plans.admin.pickerPackage.other': '{count} სესია',
  'plans.admin.kind.classPack': 'ჯგუფური ვარჯიშების პაკეტს',
  'plans.admin.field.classes': 'ჯგუფური ვარჯიშები',
  'plans.admin.field.classesHint': 'თითო ვიზიტით წევრი ადგილს ერთ-ერთ ამ ვარჯიშზე ჯავშნის.',
  'plans.admin.field.visitCount': 'ვიზიტები',
  'plans.admin.classPackHint': 'იყიდება როგორც ნებისმიერი პაკეტი; გადახდის შემდეგ წევრი ამ ვიზიტებს აქ მითითებულ ჯგუფურ ვარჯიშებზე ჯავშნის. აბონემენტს არ იძლევა.',
  'plans.admin.noClassesToPick': 'ჯერ დაამატეთ ჯგუფური ვარჯიში.',
  'plans.admin.badge.classPack': 'ჯგუფური ვარჯიშების პაკეტი',
  'plans.classPack.one': '{count} ჯგუფური ვარჯიშის ვიზიტი, გამოსაყენებელი {days} დღეში',
  'plans.classPack.other': '{count} ჯგუფური ვარჯიშის ვიზიტი, გამოსაყენებელი {days} დღეში',
  'plans.admin.pickerClassPack.one': '{count} ჯგუფური ვიზიტი',
  'plans.admin.pickerClassPack.other': '{count} ჯგუფური ვიზიტი',

  'sell.sessions': 'სესიები',
  'sell.sessionsValue': '{count}, {date}-მდე',
  'sell.classVisits': 'ჯგუფური ვიზიტები',

  'memberSessions.nav': 'სესიები',
  'memberSessions.title': 'ჩემი სესიები',
  'memberSessions.description': 'თქვენი ინდივიდუალური სესიები და მათი პაკეტები.',
  'memberSessions.book': 'სესიის დაჯავშნა',
  'memberSessions.upcoming': 'მომავალი',
  'memberSessions.recent': 'წარსული',
  'memberSessions.emptyUpcoming': 'მომავალი სესიები არ გაქვთ',
  'memberSessions.emptyUpcomingHint': 'დაჯავშნეთ სესია და ის აქ გამოჩნდება.',
  'memberSessions.emptyRecent': 'წარსული სესიები ჯერ არ გაქვთ.',
  'memberSessions.packages': 'დარჩენილი სესიები',
  'memberSessions.noPackages': 'სესიების პაკეტი არ გაქვთ.',
  'memberSessions.buyPackage': 'პაკეტის ყიდვა',
  'memberSessions.packageLeft': 'დარჩა {left} / {total}',
  'memberSessions.packageUseBy': 'გამოიყენეთ {date}-მდე',
  'memberSessions.packageExpired': 'ვადა გაუვიდა {date}-ს',
  'memberSessions.packageRefunded': 'თანხა დაბრუნდა',
  'memberSessions.with': '{name}-თან',
  'memberSessions.payAtGym': 'გადაიხადეთ {price} დარბაზში',
  'memberSessions.cancel': 'გაუქმება',
  'memberSessions.cancelTitle': 'გავაუქმოთ ეს სესია?',
  'memberSessions.cancelReturns': 'სესია თქვენს პაკეტს დაუბრუნდება.',
  'memberSessions.cancelKeeps': 'სესია {hours} საათზე ნაკლებ დროში იწყება, ამიტომ გამოყენებულად ჩაითვლება.',
  'memberSessions.cancelled': 'სესია გაუქმდა',
  'memberSessions.returned': 'სესია პაკეტს დაუბრუნდა',
  'memberSessions.kept': 'სესია გამოყენებულად ჩაითვალა',
  'memberSessions.bookTitle': 'სესიის დაჯავშნა',
  'memberSessions.bookDescription': 'აირჩიეთ სესია, ვისთან და თქვენთვის მოსახერხებელი დრო.',
  'memberSessions.back': 'ჩემი სესიები',
  'memberSessions.step.type': 'რა',
  'memberSessions.step.host': 'ვისთან',
  'memberSessions.step.day': 'რომელ დღეს',
  'memberSessions.step.time': 'რომელ საათზე',
  'memberSessions.anyone': 'ვინც თავისუფალია',
  'memberSessions.noTypes': 'დარბაზი სესიების ჯავშნებს ჯერ არ იღებს.',
  'memberSessions.noHosts': 'ამ სესიას ჯერ არავინ ატარებს.',
  'memberSessions.noSlots': 'ამ დღეს თავისუფალი დრო არ არის. სცადეთ სხვა დღე.',
  'memberSessions.needPackage': 'ეს სესია პაკეტიდან იჯავშნება და სესიები აღარ დაგრჩათ.',
  'memberSessions.confirmTitle': 'დავჯავშნოთ ეს სესია?',
  'memberSessions.confirm': 'დაჯავშნა',
  'memberSessions.booked': 'დაჯავშნილია. გელოდებით!',
  'memberSessions.fromPackage': 'თქვენი პაკეტიდან ერთ სესიას იყენებს.',
  'memberSessions.typeLine': '{minutes} წთ · {detail}',
  'memberSessions.waiting': 'ელოდება დადასტურებას',
  'memberSessions.declined': 'უარყოფილია',
  'memberSessions.lapsed': 'უპასუხოდ დარჩა',
  'memberSessions.declineReason': 'მიზეზი: {reason}',
  'memberSessions.lapsedHint': 'მოთხოვნას დროულად არ უპასუხეს.',
  'memberSessions.requestTitle': 'გავაგზავნოთ მოთხოვნა?',
  'memberSessions.request': 'მოთხოვნის გაგზავნა',
  'memberSessions.confirmsWithin': '{name} დაადასტურებს {hours} საათის განმავლობაში.',
  'memberSessions.requestNote': 'თქვენ აგზავნით მოთხოვნას, რომელიც {hours} საათის განმავლობაში დადასტურდება.',
  'memberSessions.requested': 'მოთხოვნა გაიგზავნა. შეგატყობინებთ, როცა გიპასუხებენ.',
  'memberSessions.withdraw': 'გაუქმება',
  'memberSessions.withdrawTitle': 'გავაუქმოთ ეს მოთხოვნა?',
  'memberSessions.withdrawn': 'მოთხოვნა გაუქმდა',
  'memberSessions.payNow': 'გადახდა ახლავე · {price}',
  'memberSessions.payOnline': 'გადაიხადეთ {price} ონლაინ',
  'memberSessions.payAtGymAction': 'გადახდა დარბაზში',
  'memberSessions.payChoiceHint': 'გადაიხადეთ ახლავე ონლაინ ან {price} დარბაზში. ონლაინ გადახდისას დროს თქვენთვის ვინახავთ, ხოლო თუ გადახდა არ შედგა, ვათავისუფლებთ.',
  'memberSessions.payRequiredHint': 'ეს სესია ონლაინ იხდება. გადახდისას დროს თქვენთვის ვინახავთ, ხოლო თუ გადახდა არ შედგა, ვათავისუფლებთ.',
  'memberSessions.awaitingPayment': 'ელოდება გადახდას',
  'memberSessions.heldUntil': 'თქვენთვის დაცულია {time}-მდე',
  'memberSessions.completePayment': 'გადახდა',
  'memberSessions.paidOnline': 'გადახდილია ონლაინ',
  'memberSessions.refundedOnline': 'თანხა დაბრუნდა',
  'memberSessions.paymentKept': 'გადახდილი თანხა არ ბრუნდება.',
  'memberSessions.cancelRefunds': 'ონლაინ გადახდილი თანხა სრულად დაგიბრუნდებათ.',
  'memberSessions.cancelKeepsPayment': 'სესია {hours} საათზე ნაკლებ დროში იწყება, ამიტომ გადახდილი თანხა არ დაგიბრუნდებათ.',
  'memberSessions.cancelReason': 'მიზეზი: {reason}',
  'memberSessions.reason.notPaid': 'დრო გათავისუფლდა, რადგან გადახდა დროულად არ შესრულდა.',
  'memberSessions.reason.paymentFailed': 'დრო გათავისუფლდა, რადგან გადახდა ვერ შედგა.',
  'memberSessions.returnPaid': 'თქვენი სესია დაჯავშნილია.',
  'memberSessions.returnPending': 'ველოდებით ბანკის მიერ გადახდის დადასტურებას. სანამ დადასტურდება, დრო თქვენთვის დაცულია.',
  'memberSessions.returnFailed': 'გადახდა ვერ შედგა და დრო გათავისუფლდა.',
  'memberSessions.returnRefunded': 'გადახდილი თანხა დაგიბრუნდათ.',
  'memberSessions.returnReleased': 'გადახდა მივიღეთ, მაგრამ დრო უკვე გათავისუფლებული იყო. დარბაზს შევატყობინეთ და თქვენ დაგიკავშირდებიან.',
  'memberSessions.viewSessions': 'ჩემი სესიების ნახვა',
};
